// extracted by mini-css-extract-plugin
export default {"root":"OrgsKits_root__r3ymc","hasPopup":"OrgsKits_hasPopup__3bY9t","placeHolderShimmer":"OrgsKits_placeHolderShimmer__Zslny"};